import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  TextField,
  Button,
  Container,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  DatePicker,
  CircularProgress,
} from "@mui/material";

import axios from "axios";

function UpdaterecipesSubrecipes() {
  const { title_id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    user_id: "",
    category_id: "",
    category_name: "",
    post_name: "",
    mealType_name: "",
    title_name: "",
    totalrating: "",
    totalreviewrecipe_message: "",
    url: "",
    difficulty_level: "",
    dietary_info: "",
    cuisine: "",
    short_description: "",
    author_name: "",
    likes: "",
    tags: [],
    views: "",
    created_at: new Date(),
    updated_at: new Date(),
    is_featured: false,

    title_id: "",

    ingredient_name: "",
    prep_time: "",
    cook_time: "",
    num_servings: "",
    nutri_facts: "",
    equiprecipe_title: "",
    summary: "",
    instructions: "",
    alternative_methods: "",
    cooking_tips: "",
    expert_tips: "",
    faqs: "",
    // tags: "",
    choice: "",
    // created_at: "",
    // updated_at: "",
  });

  //   const handleChange = (e) => {
  //     const { name, value, type, checked } = e.target;
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: type === "checkbox" ? checked : value,
  //     }));
  //   };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTagsChange = (e) => {
    setFormData({
      ...formData,
      tags: e.target.value.split(",").map((tag) => tag.trim()),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${API_URL}/recipe/update-recipes-subrecipes/${title_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update recipe");
      }

      alert("Recipe updated successfully: " + result.message);
    } catch (err) {
      alert("Update failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  //   const handleSubmit = async (e) => {
  //     e.preventDefault();
  //     try {
  //       const response = await axios.post(
  //         "http://localhost:3050/api/recipe/recipeadder",
  //         formData
  //       );
  //       alert(response.data.message);
  //     } catch (error) {
  //       alert("Error: " + error.response.data.message);
  //     }
  //   };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Add a Recipes and subrecipes
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* User ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="User ID"
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Category ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Category ID"
              name="category_id"
              value={formData.category_id}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              label="Total Rating"
              name="totalrating"
              value={formData.totalrating}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Title ID */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title ID"
              type="number"
              name="title_id"
              value={formData.title_id}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              label="review message"
              name="totalreviewrecipe_message"
              value={formData.totalreviewrecipe_message}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Category Name */}
          <Grid item xs={12}>
            <TextField
              label="Category Name"
              name="category_name"
              value={formData.category_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Post Name */}
          <Grid item xs={12}>
            <TextField
              label="Post Name"
              name="post_name"
              value={formData.post_name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Meal Type */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Meal Type"
              name="mealType_name"
              value={formData.mealType_name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Title Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Title Name"
              name="title_name"
              value={formData.title_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Short Description */}
          <Grid item xs={12}>
            <TextField
              label="Short Description"
              name="short_description"
              value={formData.short_description}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Author Name */}
          <Grid item xs={12}>
            <TextField
              label="Author Name"
              name="author_name"
              value={formData.author_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Difficulty Level */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Difficulty Level"
              name="difficulty_level"
              value={formData.difficulty_level}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Dietary Info */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Dietary Info"
              name="dietary_info"
              value={formData.dietary_info}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Cuisine */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Cuisine"
              name="cuisine"
              value={formData.cuisine}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* URL */}
          <Grid item xs={12}>
            <TextField
              label="URL"
              name="url"
              value={formData.url}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Tags */}
          <Grid item xs={12}>
            <TextField
              label="Tags (comma separated)"
              name="tags"
              value={formData.tags.join(", ")}
              onChange={handleTagsChange}
              fullWidth
            />
          </Grid>

          {/* Views */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Views"
              name="views"
              value={formData.views}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Likes */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Likes"
              name="likes"
              value={formData.likes}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Date Picker for Created At */}

          {/* Date Picker for Updated At */}

          {/* Featured Checkbox */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_featured}
                  onChange={handleChange}
                  name="is_featured"
                />
              }
              label="Is Featured?"
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {/* Ingredient Name */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Ingredient Name"
              name="ingredient_name"
              value={formData.ingredient_name}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Preparation Time */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Preparation Time (mins)"
              name="prep_time"
              type="number"
              value={formData.prep_time}
              onChange={handleChange}
            />
          </Grid>

          {/* Cooking Time */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Cooking Time (mins)"
              name="cook_time"
              type="number"
              value={formData.cook_time}
              onChange={handleChange}
            />
          </Grid>

          {/* Number of Servings */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Number of Servings"
              name="num_servings"
              type="number"
              value={formData.num_servings}
              onChange={handleChange}
            />
          </Grid>

          {/* Nutritional Facts */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nutritional Facts"
              name="nutri_facts"
              value={formData.nutri_facts}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Equipment Recipe Title */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Equipment Recipe Title"
              name="equiprecipe_title"
              value={formData.equiprecipe_title}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Summary */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Summary"
              name="summary"
              value={formData.summary}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Instructions */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Instructions"
              name="instructions"
              value={formData.instructions}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Alternative Methods */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Alternative Methods"
              name="alternative_methods"
              value={formData.alternative_methods}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Cooking Tips */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Cooking Tips"
              name="cooking_tips"
              value={formData.cooking_tips}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Expert Tips */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Expert Tips"
              name="expert_tips"
              value={formData.expert_tips}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* FAQs */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="FAQs"
              name="faqs"
              value={formData.faqs}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>

          {/* Tags */}

          {/* Choice */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Choice"
              name="choice"
              value={formData.choice}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Created At"
              type="datetime-local"
              variant="outlined"
              fullWidth
              name="created_at"
              value={formData.created_at}
              onChange={handleChange}
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Updated At"
              type="datetime-local"
              variant="outlined"
              fullWidth
              name="updated_at"
              value={formData.updated_at}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12} sm={6}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit Recipe"
              )}
            </Button>
          </Grid>
        </Grid>
      </form>
      {error && (
        <Typography color="error" variant="body2" mt={2}>
          {error}
        </Typography>
      )}

      {successMessage && (
        <Typography color="primary" variant="body2" mt={2}>
          {successMessage}
        </Typography>
      )}
    </Container>
  );
}

export default UpdaterecipesSubrecipes;
